import { getOffers } from '../api/Offers';
import { OffersStore } from '../store/offers';

function getOrFetchOffers() {
  if (OffersStore.isFetched()) {
    return OffersStore.getValue();
  }

  return updateOffers();
}

async function updateOffers() {
  const offers = await getOffers();
  OffersStore.update(offers);
  return offers;
}

async function getOffersWithPriceChange(productsForOrder) {
  const offersInCart = productsForOrder?.filter(p => p.isSpecialOffer);
  if (!offersInCart?.length) return [];

  const allOffers = await updateOffers();
  const offersWithChangedPrice = offersInCart.map(
    offerFromCart => allOffers.find(
      offer => offer._id === offerFromCart._id && offer.price !== offerFromCart.price)
  );
  return offersWithChangedPrice.filter(o => o);
}

export { getOrFetchOffers, updateOffers, getOffersWithPriceChange };
